module.exports = __webpack_public_path__ + "img/cs-iosclub-6.73c7d6d4.jpg";